
import { defineComponent } from 'vue'
import { setI18nLanguage } from '@/i18n'
import { LanguagesType } from '@/types'
import { constants } from '@/constants'
import AsahiLogoNew from '@/components/library/assets/AsahiLogoNew.vue'
import AsahiButton from '@/components/library/AsahiButton.vue'
import { LinksActionType } from '@/store/modules/links/interfaces'
import { IPortalHardCodeLink } from '@/store/modules/links/interfaces/IPortalHardCodeLink'
import refreshAfterChangeLanguage from '@/mixins/refreshAfterChangeLanguage'
import { Collapse } from 'bootstrap'
import AsahiBsFooter from '@/components/library/AsahiBsFooter.vue'

interface HeaderData {
  label: string;
  children: any[];
  name: string;
  href: string;
}

export default defineComponent({
  name: 'BeforeLoginLayout',
  components: {
    AsahiButton,
    AsahiLogoNew,
    AsahiBsFooter
  },
  emits: ['languagechange'],
  data: () => ({
    activeLanguage: (localStorage.getItem('lang')) as LanguagesType,
    theme: constants.application.theme,
    openLanguage: false
  }),
  mixins: [refreshAfterChangeLanguage],
  inject: ['isMobile'],
  computed: {
    user () {
      return this.$store.state.auth.user
    },

    languages () {
      return ['it', 'en']
    },
    portalHardCodeLink (): IPortalHardCodeLink[] {
      return this.$store.state.links.portalHardCodeLink?.results ?? []
    },
    portalPageMenuLink () {
      const headerMenu:HeaderData[] = this.$store.state.links.portalPageMenuLink?.items ?? [] as HeaderData[]
      return headerMenu
    },
    footerBottomLinks () {
      let footerBottomLink = [] as IPortalHardCodeLink[]
      if (this.portalHardCodeLink.length > 0) {
        footerBottomLink = this.portalHardCodeLink.filter((lnk) => lnk.type === 'About Us')
      }
      return footerBottomLink
    }
  },
  mounted () {
    if (localStorage?.getItem('lang') === 'null') {
      this.activeLanguage = this.languages[0] as LanguagesType
    } else {
      this.activeLanguage = (localStorage?.getItem('lang') || this.languages[0]) as LanguagesType
    }
    setI18nLanguage(this.activeLanguage)
    this.fetchPortalPageMenuLink()
    this.fetchPortalHardCodeLink()
  },

  methods: {
    refresh () {
      this.fetchPortalPageMenuLink()
      this.fetchPortalHardCodeLink()
    },
    closeLangAccordion () {
      const myCollapse = document.getElementById('asahi-bs-footer-accordion-collapse-language')
      if (myCollapse?.classList.contains('show')) {
        Collapse(myCollapse, {
          toggle: true
        })
      }
    },

    openLanguageDropdown () {
      this.openLanguage = !this.openLanguage
    },
    changeLanguage (langCode: LanguagesType) {
      this.activeLanguage = langCode
      setI18nLanguage(langCode)
    },
    getFullLanguageName (code: string): string {
      const languageMap: { [key: string]: string } = { en: 'English', it: 'Italiano' }
      return languageMap[code] || code
    },
    fetchPortalPageMenuLink () {
      this.$store.dispatch(LinksActionType.FETCH_PAGE_MENU_PUBLIC_LINK)
    },
    fetchPortalHardCodeLink () {
      this.$store.dispatch(LinksActionType.FETCH_PORTAL_HARD_CODE_LINK)
    },
    getRoutingPath (menuItem: HeaderData) {
      let routingPath = '/'
      if (menuItem.children.length <= 0) {
        routingPath = menuItem.href ?? ''
      } else {
        routingPath = menuItem.children[0].href ?? ''
      }
      return routingPath
    }
  }
})
